import { Link } from "react-router-dom";
import { ShieldCheck, Lock, BadgeCheck } from "lucide-react";
import { SHARED } from "../content/site";
import { cashbackPromotionEnabled } from "../config/promotions";

const TrustItem = ({ icon: Icon, label }) => (
  <div className="flex items-center gap-2 text-xs text-[#0B1220]">
    <span className="w-7 h-7 rounded-full bg-[#0F766E]/10 grid place-items-center">
      <Icon className="w-3.5 h-3.5 text-[#0F766E]" />
    </span>
    <span className="font-medium">{label}</span>
  </div>
);

const Footer = () => (
  <footer className="border-t border-[#DCE7E3] bg-white mt-24">
    <div className="mp-container pt-12 pb-8">
      <div className="flex flex-wrap gap-4 justify-between rounded-2xl border border-[#DCE7E3] bg-[#F7FAF9] px-5 py-4">
        <TrustItem icon={ShieldCheck} label="Educational guidance only" />
        <TrustItem icon={Lock} label="No credit checks · No obligation" />
        <TrustItem icon={BadgeCheck} label="Sources we trust: GOV.UK, HMRC, RICS" />
      </div>

      <div className="mt-12 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <div className="font-sora font-bold tracking-tight text-[#0F766E] text-2xl">
            Mortgage<span className="text-[#10B981]">Path</span>
          </div>
          <p className="mt-4 text-sm text-[#475569] max-w-md leading-relaxed">
            MortgagePath provides educational information only and does not provide regulated mortgage advice.
            We do not recommend specific lenders, products or rates, and we do not make lending decisions.
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold text-[#0B1220] mb-3 font-sora">Explore</div>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/calculator" className="hover:text-[#0F766E]">Mortgage Calculator</Link></li>
            <li><Link to="/stamp-duty-calculator" className="hover:text-[#0F766E]" data-testid="footer-link-stamp-duty">Stamp Duty Calculator</Link></li>
            <li><Link to="/snapshot" className="hover:text-[#0F766E]">Mortgage Snapshot</Link></li>
            <li><Link to="/first-time-buyer-guide" className="hover:text-[#0F766E]">First-Time Buyer Guide</Link></li>
            <li><Link to="/remortgage-guide" className="hover:text-[#0F766E]">Remortgage Guide</Link></li>
            <li><Link to="/faqs" className="hover:text-[#0F766E]">FAQs</Link></li>
            {cashbackPromotionEnabled && (
              <li><Link to="/cashback" className="hover:text-[#0F766E]" data-testid="footer-link-cashback">£100 Cashback</Link></li>
            )}
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-[#0B1220] mb-3 font-sora">Company</div>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/about" className="hover:text-[#0F766E]" data-testid="footer-link-about">About MortgagePath</Link></li>
            <li><Link to="/editorial-standards" className="hover:text-[#0F766E]" data-testid="footer-link-editorial">Editorial Standards</Link></li>
            <li><Link to="/contact" className="hover:text-[#0F766E]">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-[#0B1220] mb-3 font-sora">Legal</div>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/privacy" className="hover:text-[#0F766E]" data-testid="footer-link-privacy">Privacy Policy</Link></li>
            <li><Link to="/cookies" className="hover:text-[#0F766E]" data-testid="footer-link-cookies">Cookie Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#0F766E]" data-testid="footer-link-terms">Terms of Use</Link></li>
            <li>
              <button
                type="button"
                onClick={() => { if (typeof window !== "undefined") window.dispatchEvent(new Event("mp:open-cookie-settings")); }}
                className="hover:text-[#0F766E] text-left"
                data-testid="footer-cookie-settings"
              >
                Cookie settings
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-[#DCE7E3]">
      <div className="mp-container py-5 text-xs text-[#475569] leading-relaxed space-y-3">
        <p data-testid="footer-company">{SHARED.companyLine}</p>
        <div className="flex flex-wrap gap-4 justify-between">
          <span>
            <strong className="text-[#0B1220]">Commission disclosure.</strong> Where you follow an optional link to our
            broker partner and take out a mortgage through them, MortgagePath may receive a commission from that broker.
            This does not increase what you pay. Where you use our conveyancing or survey partner services, MortgagePath
            may receive a referral fee.
          </span>
          <span>© {new Date().getFullYear()} MortgagePath. All rights reserved.</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
